import { createAction, props } from '@ngrx/store';
import {
  IngredientWithProduct,
  MappedIngredient,
  NewProductToComponents,
  NewProductToIngredientsWithProduct,
} from '../../models/ingredient';
import { LinkProductToIngredientBody, UnlinkProductFromIngredientBody } from '../../api/product.api';
import { CreateDishWithLinkRequest } from '../../api/models/create-dish-with-link';

export enum IngredientAction {
  GetIngredient = '[Ingredient] Get Ingredient',
  GetIngredientSuccess = '[Ingredient] Get Ingredient Success',
  LinkProduct = '[Ingredient] Link Product',
  LinkProductSuccess = '[Ingredient] Link Product Success',
  LinkProductFailure = '[Ingredient] Link Product Failure',
  CreateProductWithLinkToIngredient = '[Ingredient] Create Product With Link To Ingredient',
  CreateProductWithLinkToIngredientSuccess = '[Ingredient] Create Product With Link To Ingredient Success',
  CreateProductWithLinkToIngredientFailure = '[Ingredient] Create Product With Link To Ingredient Failure',
  UnlinkProduct = '[Ingredient] Unlink Product',
  UnlinkProductSuccess = '[Ingredient] Unlink Product Success',
  UnlinkProductFailure = '[Ingredient] Unlink Product Failure',
  UpdateLinkProduct = '[Ingredient] Update Link Product',
  UpdateLinkProductSuccess = '[Ingredient] Update Link Product Success',
  UpdateLinkProductFailure = '[Ingredient] Update Link Product Failure',
  MakeLinkActive = '[Ingredient] Make Link Active',
  MakeLinkActiveSuccess = '[Ingredient] Make Link Active Success',
  MakeLinkActiveFailure = '[Ingredient] Make Link Active Failure',
  ClearIngredient = '[Ingredient] Clear Ingredient',
}

export const getIngredient = createAction(
  IngredientAction.GetIngredient,
  props<{ componentId: string }>()
);

export const getIngredientSuccess = createAction(
  IngredientAction.GetIngredientSuccess,
  props<{ ingredient: MappedIngredient }>()
);

export const clearIngredient = createAction(
  IngredientAction.ClearIngredient
);

export const linkProduct = createAction(
  IngredientAction.LinkProduct,
  props<LinkProductToIngredientBody & { productId: number }>()
);

export const linkProductSuccess = createAction(
  IngredientAction.LinkProductSuccess,
  props<{ linkedProduct: IngredientWithProduct }>()
);

export const linkProductError = createAction(
  IngredientAction.LinkProductFailure,
  props<{ message: string }>()
);

export const createProductWithLinkToIngredient = createAction(
  IngredientAction.CreateProductWithLinkToIngredient,
  props<{ product: CreateDishWithLinkRequest }>()
);

export const createProductWithLinkToIngredientSuccess = createAction(
  IngredientAction.CreateProductWithLinkToIngredientSuccess,
  props<{ linkedProduct: IngredientWithProduct }>()
);

export const createProductWithLinkToIngredientError = createAction(
  IngredientAction.CreateProductWithLinkToIngredientFailure,
  props<{ message: string }>()
);

export const updateLinkProduct = createAction(
  IngredientAction.UpdateLinkProduct,
  props<Partial<LinkProductToIngredientBody> & { productId: number }>()
);

export const updateLinkProductSuccess = createAction(
  IngredientAction.UpdateLinkProductSuccess,
  props<{ linkedProduct: IngredientWithProduct }>()
);

export const updateLinkProductError = createAction(
  IngredientAction.UpdateLinkProductFailure,
  props<{ message: string }>()
);

export const unlinkProduct = createAction(
  IngredientAction.UnlinkProduct,
  props<UnlinkProductFromIngredientBody & { productId: number }>()
);

export const unlinkProductSuccess = createAction(
  IngredientAction.UnlinkProductSuccess,
  props<{ id: number, productId: number }>()
);

export const unlinkProductError = createAction(
  IngredientAction.UnlinkProductFailure,
  props<{ message: string }>()
);

export const makeLinkActive = createAction(
  IngredientAction.MakeLinkActive,
  props<{ productId: number, componentId: string }>()
);

export const makeLinkActiveSuccess = createAction(
  IngredientAction.MakeLinkActiveSuccess,
  props<{ newLink: NewProductToComponents }>()
);

export const makeLinkActiveError = createAction(
  IngredientAction.MakeLinkActiveFailure,
  props<{ message: string }>()
);
